<template>
  <div class="box__image-header">
    <img
      v-if="project.isVerified && project.profilePic"
      :src="project.profilePic"
      alt="Verified Project Picture"
      class="box__image-header__project-image profile-image"
    />
    <div
      v-if="project.isVerified && !project.profilePic"
      alt="Verified Project Default Picture"
      class="box__image-header__project-image profile-image"
    ></div>
    <img
      v-if="!project.isVerified && project.profilePic"
      :src="project.profilePic"
      alt="Unverified Project Picture"
      class="box__image-header__project-image profile-image"
    />
    <div
      v-if="!project.isVerified && !project.profilePic"
      alt="Unverified Project Default Picture"
      class="box__image-header__project-image profile-image"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ProjectProfileImage',
  props: {
    project: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/layout';

.profile-image {
  border-radius: 8px 8px 0 0;
}
</style>
